import { Tooltip } from '@mui/material';
import { ICellRendererParams } from 'ag-grid-community';

interface IProps extends ICellRendererParams {
    GroupName: string;
    Count: number;
    ClassName?: string;
    Label: string;
    campaignName?: string
}

export const ToFieldRender = (props: IProps) => {
    return (
        <div className='d-flex'>
            {!!props?.campaignName ?
                <Tooltip title={<>
                    Campaign
                </>}>
                    <span className={` my-auto ml-1 ${props.ClassName}`}>{props?.campaignName}</span>
                </Tooltip>
                :
                props.GroupName &&
                <Tooltip title={<>
                    Number of contacts in {props.GroupName}:    {props.Count}
                </>}>
                    <span className={`grid-btn-text my-auto ml-1 ${props.ClassName}`}>{props.GroupName}</span>
                </Tooltip>
            }
            {
                !props?.campaignName && <span className='p-1 my-auto'>{props.Label}</span>
            }
        </div>
    )
}
